// extracted by mini-css-extract-plugin
export var container = "_i3-0";
export var content = "_i3-3";
export var customerTitle = "_i3-4";
export var empty = "_i3-5";
export var gray = "_i3-6";
export var header = "_i3-7";
export var info = "_i3-8";
export var loading = "_i3-2";
export var loadingCard = "_i3-9";
export var oneLine = "_i3-a";
export var personName = "_i3-e";
export var pillContainer = "_i3-b";
export var selected = "_i3-1";
export var text = "_i3-c";
export var twoLines = "_i3-d";
export var unread = "_i3-f";
export var unreadIndicator = "_i3-g";